import React from 'react'
import { RenderItemProps } from './types'
import { DebugItem } from './shared'
import { StoriesCard } from '@/components/Cards/Stories'
import { variantProvider } from '@/app'
import { ScrollWrapper } from './ScrollWrapper'
import { TagType } from '../atoms/TagType'

export const FeedStory = (props: RenderItemProps) => {
  const { item } = props

  const story = item.story

  return (
    <>
      <DebugItem {...props} />

      <ScrollWrapper>
        <StoriesCard story={story} showOrganisation={true} replies={story.replies} asLink>
          <TagType text='Success story' icon='trophy' />
        </StoriesCard>
      </ScrollWrapper>
    </>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({}), true)
